import logo from '../assets/logo.png';
// import logo from '../assets/logo-1.png';

export default function Navbar () {
    return (
        <div className="bg-light _navbar sticky-top">
            <img src={logo} width={100} alt="Logo" />
        </div>
    )
}